import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';

interface LeadAssessmentOption {
  id: boolean | null;
  name: string;
}

interface LeadAssessmentFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

const leadAssessmentOptions: LeadAssessmentOption[] = [
  { id: null, name: 'Account Assessments' },
  { id: true, name: 'Lead Assessments' },
];

export const LeadAssessmentFilter: React.FC<LeadAssessmentFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedOption = leadAssessmentOptions.find(
    (o) => o.id === (String(value) === 'true' ? true : null)
  );

  if (valueOnly) {
    return <>{selectedOption?.name || ''}</>;
  }

  return (
    <Autocomplete
      options={leadAssessmentOptions}
      getOptionLabel={(option) => option.name}
      value={selectedOption || null}
      onChange={(_, newValue) => {
        setValue(newValue?.id?.toString() || '');
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Assessment Type"
        />
      )}
    />
  );
};
